export enum PaidStatuses {
    UNCOMMITTED = 'Uncommitted',
    UNPAID = 'Unpaid',
    MARKED_AS_PAID_BY_BUYER = 'MarkedAsPaidByBuyer',
    MARKED_AS_PAID_BY_SELLER = 'MarkedAsPaidBySeller',
    PAYMENT_PENDING = 'PaymentPending',
    PAID = 'Paid',
    EXPIRED = 'Expired',
}
